import { Input } from "../input"
import { MdSearch } from "react-icons/md";
import { ModuleHeader } from "../module-header"
import SupportActionItem from "./support-ticket-item"
import {
    SupportTicketCardWrapper,
    SupportSectionContainer,
    SupportTicketTopSection,
    InputContainer
}
    from "./support-ticket.style"
import { SelectContainer } from "../dashboard-overview/dashboard-overview.style";

const SupportTicket = ({ category }) => {
    return (
        <SupportSectionContainer>
            <ModuleHeader title={category} />
            <SupportTicketCardWrapper>
                <SupportTicketTopSection>
                    <InputContainer>
                        <Input
                            startAdornment={<MdSearch />}
                            placeholder='Search'
                            className="search"
                        />
                    </InputContainer>

                    <SelectContainer style={{ marginLeft: 'auto' }}>
                        <select>
                            <option value="">Sort by</option>
                            <option value="date">Date</option>
                            <option value="time">Time</option>
                            <option value="day">Day</option>
                        </select>
                    </SelectContainer>
                </SupportTicketTopSection>
                <SupportActionItem
                    category={category}
                    title="I NEED HELP!"
                    date="2 days ago"
                    longText="For some reason, I can’t open my subject..."
                />
                <SupportActionItem
                    category={category}
                    title="LOGGING ISSUES"
                    date="3 days ago"
                    longText="Lorem ipsum, dolor sit amet consectetur adipisicing elit. Saepe adipisci reiciendis labore iusto eaque sequi dolor illo, voluptas vitae ex, aliquam voluptatum repellendus. Praesentium veniam placeat reprehenderit nemo voluptatum debitis dolorum laborum minima velit? Libero, vero. Consectetur repudiandae aspernatur vero inventore recusandae nam distinctio, eveniet sequi, maxime provident quasi ex!"
                />

                <SupportActionItem
                    category={category}
                    title="DOWNLOAD ISSUES"
                    date="4 weeks"
                    longText="Hi, I cannot seem to download my English assignmen... "
                />
            </SupportTicketCardWrapper>
        </SupportSectionContainer>
    )
}

export { SupportTicket }
